'use client';

import Text, { TEXT_TAG, TEXT_VARIANT } from '@pixum/text';
import { TextInput } from '@pixum/web-input';
import { Checkbox } from '@pixum/web-checkbox';
import { PAYMENT_FORM_ID, SEPA_FIELD, SEPA_INPUT_NAME } from '../../../../constants';
import type { SepaBankAccountDetail, SepaField, SepaValues } from '../../../../types';
import styles from './SepaPaymentMethod.module.css';

interface SepaPaymentMethodProps {
  constants: Record<string, string>;
  values: SepaValues;
  errors: Partial<Record<SepaField, string>>;
  onChange: <K extends keyof SepaValues>(field: K, value: SepaValues[K]) => void;
}

export function SepaPaymentMethod({ constants, values, errors, onChange }: SepaPaymentMethodProps) {
  const renderTextInput = (field: SepaBankAccountDetail, label: string) => (
    <TextInput
      label={label}
      form={PAYMENT_FORM_ID}
      name={SEPA_INPUT_NAME[field]}
      value={values[field]}
      onChange={event => onChange(field, event.target.value)}
      hasError={Boolean(errors[field])}
      inputInfo={errors[field]}
    />
  );

  return (
    <div className={styles.sepaPaymentMethod}>
      {constants['i18n_sepa_desc'] && (
        <Text variant={TEXT_VARIANT.SUBHEADLINE} tag={TEXT_TAG.P}>
          {constants['i18n_sepa_desc']}
        </Text>
      )}
      {renderTextInput(SEPA_FIELD.HOLDER, constants['i18n_sepa_payee'])}
      {renderTextInput(SEPA_FIELD.IBAN, constants['i18n_payment_iban'])}
      {renderTextInput(SEPA_FIELD.BIC, constants['i18n_payment_bic'])}
      {renderTextInput(SEPA_FIELD.BANK_NAME, constants['i18n_sepa_bank_name'])}
      <Checkbox
        id={SEPA_INPUT_NAME[SEPA_FIELD.ACCEPTED]}
        name={SEPA_INPUT_NAME[SEPA_FIELD.ACCEPTED]}
        checked={values.accepted}
        onChange={checked => onChange(SEPA_FIELD.ACCEPTED, checked)}
        hasError={Boolean(errors[SEPA_FIELD.ACCEPTED])}
        info={errors[SEPA_FIELD.ACCEPTED]}
        label={constants['i18n_sepa_acceptance']}
      />
    </div>
  );
}
